/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';

import { token } from '@atlaskit/tokens';

export const NameCellContainer = styled.div<{
  padding: number;
}>(props => ({
  display: 'flex',
  padding: `${props.padding}px`,
  alignItems: 'center',
  '&:hover, &:focus': {
    cursor: 'default',
  },
}));

export const NameCellAvatar = styled.div({
  marginRight: token('space.100'),
});

export const NameCellText = styled.div({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
});
